import { lazy } from "react";

export const KoalaPhrasesPage = lazy(() => import("./koalaPhrasesPage"));
